import React, { useEffect, useState } from 'react';
import {
  AppBar, Toolbar, Typography, Box, Tabs, Tab, Grid, Card, CardMedia,
  CardContent, Paper, IconButton, Button, Container,
  CircularProgress
} from '@material-ui/core';
import {
  Facebook, Instagram, LinkedIn, YouTube,WhatsApp,Share
} from '@material-ui/icons';
import Slider from 'react-slick';
import './businessProfile.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { useParams } from 'react-router-dom';

import api from '../Dashboard/SiteManager/api';
import Helmet_tags from '../common/Helmet/helmet';
import { toast } from 'react-toastify';
import CommonCard from './CommonCard';
import { QRCode } from 'react-qrcode-logo'
export default function BusinessProfile() {


  const {id}=useParams()
  const [tabIndex, setTabIndex] = useState(0);
  const s3_site_url = 'https://d6-halo.s3.us-east-2.amazonaws.com/static/media/';

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:3,
    slidesToScroll: 1,
  
    responsive: [
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 960,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1280,
        settings: { slidesToShow: 3 }
      }
    ]
  };

  const  currencyArray = [
  { ID: 1, name: 'usa', symbol: '$' },          
  { ID: 2, name: 'india', symbol: '₹' },        
  { ID: 3, name: 'canada', symbol: '$' },     
  { ID: 4, name: 'united kingdom', symbol: '£' },
  { ID: 5, name: 'australia', symbol: '$' },   
  { ID: 6, name: 'germany', symbol: '€' },      
];
const [data, setData] = useState({});

const [siteData,setSiteData]=useState('')
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const renderSymbol=currencyArray.find(val=>val.name===(siteData.currency||'india'))?.symbol

const {categories,crousels,contact,offers,tabs}=siteData
const width = window.innerWidth;
const NextArrow = (props) => {
  const { className, onClick } = props;
  return <ArrowForwardIos className={className} onClick={onClick} style={{ color: 'black', fontSize: 24 }} />;
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return <ArrowBackIos className={className} onClick={onClick} style={{ color: 'black', fontSize: 24 }} />;
};

const allProducts = siteData?.categories?.filter(val=>val.active).flatMap(cat =>
  (cat.products || []).map(prod => ({
    ...prod,
   
  }))
).sort((a,b)=>a.priority<b.priority?-1:1) || [];
  useEffect(() => {
     const fetchSiteData = async () => {
               setLoading(true)
 
       try {
         const response = await api.get(`product-v2?memberID=${id}`);
         setSiteData(response.data);
       } catch (err) {
         console.error(err);
         window.location.href='/'
         setError(err.response?.data?.detail || 'Error fetching site');
       }
       finally{
         setLoading(false)
       }
     };
 
  if(id){
       fetchSiteData();}
       else{
        window.location.href='/'
       }
   
   }, []);


// const CommonCard=(val1)=>{

//   const val2=val1.val
// const val={...val2,origPrice:parseFloat(val2.origPrice),price:parseFloat(val2.price)}


//   return(

//      <Card className="product-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//     <CardMedia
//       component="img"
//       height="140"
//       image={`${s3_site_url}products/${val.imageN}`}
//       title={val.name}
//     />
//     <CardContent style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
//       <Typography style={{minHeight:40}} variant="body2">{val.name}</Typography>

//       <Typography
//   variant="body2"
//   style={{
//     padding: '1vh 0px',
//     color: 'gray',
//     flex: 1,
//     display: '-webkit-box',
//     WebkitLineClamp: 3,         // 👈 Limits to 3 lines
//     WebkitBoxOrient: 'vertical',
//     overflow: 'hidden',
//     textOverflow: 'ellipsis',
//     minHeight:65
//   }}
// >
//   {val?.description?.length > 100
//     ? val.description.slice(0, 100) + '...'
//     : val.description}
// </Typography>

//       <div style={{ display: 'flex', alignItems: 'center', paddingTop: '1vh' }}>
//         {val.origPrice>val.price?<Typography variant="body2" style={{ textDecoration: 'line-through', color: 'gray', marginRight: '8px' }}>
//     {renderSymbol}{val.origPrice}
//   </Typography>:null}

//   <Typography variant="h6" style={{ color: 'green', marginRight: '8px' }}>
//    {renderSymbol}{val.price>0?val.price:val.origPrice}
//   </Typography>

//   {val.origPrice>val.price?<Typography variant="body2" style={{ color: 'red' }}>
//     ({Math.round(
//   ((val.origPrice - val.price) / val.origPrice) * 100
// )}% OFF)
//   </Typography>:null}
       
//       </div>
//        <div style={{ textAlign: 'right', width: '100%' ,paddingRight:'10px'}}>
//           <WhatsApp  onClick={()=>window.open(`https://wa.me/91${val.whatsapp}?text=Hello%20${siteData?.siteName},%20I%20am%20interested%20in%20your%20${val.name}%20product`)} style={{ color: 'var(--gcolor)', paddingRight: '10px', cursor: 'pointer' }} />
//           <Share  onClick={()=>handleShare(val.share)} style={{ cursor: 'pointer' }} />
//         </div>
//     </CardContent>
//   </Card>
//   )
// }
   const renderProducts1 = (cat) => (
    <Slider  className={[cat.products.length<3?"":'sliderP', 'sliderMobile']} nextArrow={<NextArrow />}
  prevArrow={<PrevArrow />} arrows autoplay={false} slidesToShow={width<500?1:cat.products.length<3?cat.products.length:3} slidesToScroll={1} >
      {cat?.products.filter(val=>val.active).sort((a,b)=>a.priority<b.priority?-1:1).map((val, i) => (
        <div key={i} style={{ display: 'flex' }}>
<CommonCard cat={cat.name} val={val} renderSymbol={renderSymbol} handleShare={handleShare} siteData={siteData} s3_site_url={s3_site_url} />
</div>

      ))}
    </Slider>
  );
   const renderProduct2 = (cat) => (
    
    <Slider className={[cat.products.length<3?"":'sliderP', 'sliderMobile']} nextArrow={<NextArrow />}
  prevArrow={<PrevArrow />} arrows autoplay={false} slidesToShow={width<500?1:cat.products.length<3?cat.products.length:3} slidesToScroll={1} >
      {allProducts?.filter(val=>val.active)?.map((val, i) => (
     cat.products.find(val2=>val2===val.id)  ?
     
          <div key={i} style={{ display: 'flex' }}>
 <CommonCard  cat={cat.name}  val={val} renderSymbol={renderSymbol} handleShare={handleShare} siteData={siteData} s3_site_url={s3_site_url}  />
</div>:
     
     null

      ))}
    </Slider>
  );
 const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -80;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };
  const handleShare = async (val) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: siteData?.metaTitle,
        url: val,
      });
    } catch (err) {
      console.error('Share failed:', err);
    }
  } else {
    toast.error('Sharing not supported on this browser.');
  }
};

  if (loading){
return  <Box style={{width:'100%',textAlign:'center'}}><CircularProgress   size={40} style={{marginTop:'30vh',textAlign:'center'}} />
</Box>
  }
  return (


    
    <Box>
      <Helmet_tags keywords={siteData?.metaKeywords||'Halo Digital'} name={siteData?.metaTitle||'Halo Digital'} description={siteData?.metaDescription||'Halo Digital'} />
      <AppBar position="static" color="default" style={{background:'rgba(255,255,255,0.4)',position:'absolute'}} elevation={0}>
        <Toolbar className="toolbar">
            <img className="logo" src={ s3_site_url+'logo/'+siteData?.imageN} />
          <Box className="nav-buttons">
            <Button onClick={()=>handleScroll("Products")}>Products</Button>
            <Button onClick={()=>handleScroll("Location")}>📍 Our Location</Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* <Box className="hero">
        <Typography variant="h3">Season End Sale</Typography>
        <Typography variant="h6">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh </Typography>
        <Typography variant="h2" className="highlight">Upto 50% Off</Typography>
      </Box> */}
      <Slider dots={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay>
  {crousels&&crousels.filter(val=>val.active).map((val,idx)=>
  
<Box   key={idx}  className={`hero ${val.orientation==='right'?"hero-right":val.orientation==='noshow'?"hero-empty":""}`}>
<div style={{
    height:'100%',
      color: '#fff',
  textAlign: '-webkit-left',
  padding:' 4rem 0px',
  alignContent: "center",
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3)), url('${s3_site_url}crousels/${val.imageN}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  }} >

   {val.orientation!=="noshow" ?<Box className={`hero-content ${val.orientation==='right'?"hero-right":"left"}`}>
      <Typography variant="h3">{val.heading}</Typography>
      <Typography variant="h6">
        {val.moreInfo}
      </Typography>
      <Typography variant="h2" className="highlight">
        {val.subHeading}
      </Typography>
    </Box>:null}
    </div>
  </Box>

)}
{/* 
  <Box className="hero hero-right">
    <Box className="hero-content right">
      <Typography variant="h3">New Arrivals</Typography>
      <Typography variant="h6">
        Discover our premium collection of modern furniture
      </Typography>
      <Typography variant="h2" className="highlight">
        Just In!
      </Typography>
    </Box>
  </Box>

  <Box className="hero hero-empty" /> */}
</Slider>


      <Container id='Products' className="tab-section">
        <Tabs
          value={tabIndex}
          onChange={(e, newIndex) => setTabIndex(newIndex)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Categories" />
          {tabs&&tabs.filter(val=>val.active).map((val,idx)=>
         <Tab key={idx} label={val.name} /> )
          }
        </Tabs>

        <Box mt={2}>
          {tabIndex === 0 && (
            <Slider   className={[categories&&categories.length<3?"":'sliderP', 'sliderMobile']} nextArrow={<NextArrow className='arrow1' />}
  prevArrow={<PrevArrow  className='arrow2' />} arrows autoplay={false} slidesToShow={width<500?1:categories&&categories.length<3?categories&&categories.length:3} slidesToScroll={1}>
              {categories&&categories[0]&&categories.filter(val=>val.active).sort((a,b)=>a.priority<b.priority?-1:1).map((cat, i) => (
                <div   key={i}>
                  <Card onClick={()=>handleScroll(cat.name)}  style={{cursor:'pointer'}}className="product-card">
                    <CardMedia component="img" height="120"    image={`${s3_site_url}categories/${cat.imageN}`} />
                    <CardContent>
                      <Typography  style={{fontWeight:'600'}} align="left">{cat.name}</Typography>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </Slider>
          )}


          {tabIndex === 1 && renderProduct2(tabs[0])}
          {tabIndex === 2 && renderProduct2(tabs[1])}
        </Box>
      </Container>

      {categories?.filter(val=>val.active).sort((a,b)=>a.priority<b.priority?-1:1).map((cat,id) => (
        <Container      id={cat.name}
 key={id} className="carousel-container">

  <Grid item sm={12} xs={12}>


    <Typography  style={{fontSize:'1.3rem',fontWeight:'700',padding:'2vh 5px'}}>{cat.name}</Typography>
  </Grid>
          {renderProducts1(cat)}
        </Container>
      ))}

      <Container className="offers">
        <Grid container spacing={3}>
          {offers&&offers.filter(val=>val.active).map((offer, i) => (
            <Grid item xs={12} sm={4} key={i}>
              <Paper elevation={2} className="offer-box">
                <Typography variant="h6">{offer.offer}</Typography>
                <Typography variant="body2">{offer.description}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

        <Box className="contact-box">
      <Container>
        <Grid container>

          <Grid item  sm={6} xs={12}>
 <Typography variant="h6" gutterBottom>Contact Us</Typography>
        <Typography>📍 {contact?.[0]?.address}</Typography>
        <Typography>📞 {contact?.[0]?.phone}</Typography>
        <Typography>📧 {contact?.[0]?.email}</Typography>

        {/* Social Links */} 
        <Box mt={2}>
          <IconButton onClick={() => window.open(`${contact?.[0]?.facebook}`, '_blank')}>
            <Facebook />
          </IconButton>
          <IconButton onClick={() => window.open(`${contact?.[0]?.instagram}`, '_blank')}>
            <Instagram />
          </IconButton>
          <IconButton onClick={() => window.open(`${contact?.[0]?.linkedin}`, '_blank')}>
            <LinkedIn />
          </IconButton>
          <IconButton onClick={() => window.open(`https://api.whatsapp.com/send/?phone=91${contact?.[0]?.whatsapp}&text=Hello+${siteData?.siteName}%2C+I+am+interested+in+your+product&type=phone_number&app_absent=0`, '_blank')}>
            <WhatsApp />
          </IconButton>
        </Box>
          </Grid>
            <Grid   className='qrcode' style={{}} item sm={6} xs={12}>
            
             <QRCode
                      size={110}
                      value={window.location.href}
                    //   logoImage={logo}
                    ecLevel={'Q'}
                      logoOpacity='0'
                      qrStyle='dots'
                      // logoWidth='60'
                      quietZone='5'
                      fgColor='#000000'
                    
                    />   
          </Grid>
        </Grid>
       

        {/* Map */}
        <Box id="Location" mt={3}>
          <iframe
            title="Google Map"
            src={contact?.[0]?.map}
            className="map"
            allowFullScreen
            loading="lazy"
            style={{ width: '100%', height: '300px', border: 0 }}
          />
        </Box>
      </Container>
    </Box>


      <Box className="footer">
        <Typography variant="body2">{contact?.[0]?.footerText}</Typography>
      </Box>
    </Box>
  );
}
